<template>
    <section class="content">
        <section class="head">
            <img v-if="info.userIcon" :src="info.userIcon+avatarImgPostfix" />
            <img v-else :src="defaultAvatarSrc" />
        </section>
        <section class="content-right">
            <h3>{{ info.userName }}</h3>
            打分
            <v-rate v-model="info.score" disabled></v-rate>
            <p v-html="infoContentHtml"></p>
            <section class="content-img">
                <img :src="commentDetailImgSrc" :data-src="(item+commentImgPostfix)" :key="index" v-for="(item, index) in info.userCommentImage" @click="showImg(item, index)" :class="index === contentImgActive ? 'active' : ''" />
            </section>
            <section class="img-show" v-show="imgShowStatus" @click="hideImg">
                <img :src="imgShowSrc" />
            </section>
            <time>{{ info.userCommentTime }}</time>
            <a href="javascript:void(0);" class="reply-btn" @click="showReply" v-show="!replyShowStatus && !info.bizReplyContent">回复</a>
            <section class="reply-content" v-show="info.bizReplyContent && replyContentShowStatus">
                <p>商家回复：{{ info.bizReplyContent }}</p>
                <time>{{ info.bizReplyTime }}</time>
                <a href="javascript:void(0);" class="reply-btn" @click="showReply">修改</a>
            </section>
            <reply-component v-show="replyShowStatus" @cancel="hideReply" :replyContent="info.bizReplyContent" :did="info.dealId" :commentId="info.id" :poiId="info.poiId"></reply-component>
        </section>
    </section>
</template>

<style lang="postcss">
:root {
  --blueColor: #2a99f1;
}
.content {
  border-top: 1px solid #f2f3f8;
  padding: 30px;
  position: relative;
  overflow: hidden;
  & .head {
    width: 50px;
    height: 100%;
    float: left;
    & > img {
      width: 50px;
      height: 50px;
      border-radius: 50px;
    }
  }
  & .content-right {
    width: 90%;
    float: left;
    margin-right: -70px;
    margin-left: 20px;
    max-width: 980px;
    & > h3 {
      line-height: 24px;
      font-weight: normal;
    }
    & .v-rate {
      display: inline-block;
      margin-left: 5px;
      & .v-rate__icon {
        font-size: 14px;
      }
    }
    & > p {
      overflow-wrap: break-word;
      margin-top: 8px;
      & > span {
        color: #ff970f;
      }
    }
    & .content-img {
      display: flex;
      margin-bottom: 4px;
      flex-wrap: wrap;
      margin-top: 15px;
      & > img {
        width: 80px;
        height: 80px;
        margin-right: 6px;
        margin-bottom: 6px;
        object-fit: cover;
        &:nth-last-of-type(1) {
          margin-right: 0;
        }
        &.active {
          border: 3px solid var(--blueColor);
        }
      }
    }
    & .img-show {
      text-align: center;
      margin-bottom: 20px;
      & > img {
        max-width: 40%;
      }
    }
    & > time {
      color: #8f9192;
      line-height: 28px;
    }
    & .reply-btn {
      width: 70px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      color: #4c4e50;
      border: 1px solid #c6cacf;
      border-radius: 100px;
      float: right;
    }
    & .reply-content {
      margin-top: 10px;
      position: relative;
      overflow: hidden;
      background-color: #f7f9fa;
      padding: 10px 15px;
      & > time {
        color: #8f9192;
        margin-top: 15px;
        display: inline-block;
      }
      & > .reply-btn {
        margin-top: 10px;
      }
    }
  }
}
</style>

<script>
    import { Lazy_Img_Src } from "config/packageProduct";
    import ReplyComponent from "./Reply.vue";
    const avatarImgPostfix = "@50h_50w_2e_90Q",
      defaultAvatar =
        "https://p0.meituan.net/codeman/54dc25852f4a3a4321f3a5ca79c39eb619622.png";
    export default {
      components: {
        ReplyComponent
      },
      data() {
        return {
          contentImgActive: "", // 当前激活状态的缩略图index
          imgShowStatus: false, // 大图是否显示
          imgShowSrc: "", // 大图显示的src
          replyShowStatus: false, // 回复按钮是否显示
          replyContentShowStatus: true, // 商家回复框是否显示
          defaultAvatarSrc: defaultAvatar + avatarImgPostfix,
          avatarImgPostfix: avatarImgPostfix,
          commentImgPostfix: "@80h_80w_2e_90Q",
          commentDetailImgSrc: Lazy_Img_Src
        };
      },
      computed: {
        // 高亮显示标签
        infoContentHtml() {
          const tag = this.info.highlight;
          const re = new RegExp(tag, "gi");
          return this.info.userComment.replace(re, "<span>" + tag + "</span>");
        }
      },
      props: ["info"],
      methods: {
        // 显示大图
        showImg(item, index) {
          this.contentImgActive = index;
          this.imgShowStatus = true;
          this.imgShowSrc = item;
        },

        // 隐藏大图
        hideImg() {
          this.contentImgActive = "";
          this.imgShowStatus = false;
          this.imgShowSrc = "";
        },

        // 显示回复框
        showReply() {
          this.replyContentShowStatus = false;
          this.replyShowStatus = true;
        },

        // 隐藏回复框
        hideReply(res) {
          // 回复成功后更新内容
          if (res) {
            this.info.bizReplyContent = res.bizReply || this.info.bizReplyContent;
            this.info.bizReplyTime = res.replyTime || this.info.bizReplyTime;
          }
          this.replyContentShowStatus = true;
          this.replyShowStatus = false;
        }
      }
    };
</script>



// WEBPACK FOOTER //
// Content.vue?1c4eaf0f